// extracted by mini-css-extract-plugin
export var changeTypeInFormClass = "reservation-module--change-type-in-form-class--8dfa5";
export var reservationActions = "reservation-module--reservation-actions--2f037";
export var reservationActionsArrowLeft = "reservation-module--reservation-actions-arrow-left--bf8a9";
export var reservationActionsArrowRight = "reservation-module--reservation-actions-arrow-right--9d919";
export var reservationActionsWithBack = "reservation-module--reservation-actions-with-back--2c0e6";
export var reservationContainer = "reservation-module--reservation-container--c87be";